import PropTypes from 'prop-types';
import { ReactComponent as Spinner } from '../assets/images/spinner.svg';

const NewSpinnerBlock = ({ extraClass }) => (
  <div className={`w-100 ${extraClass}`}>
    <Spinner className="spinn-this" />
  </div>
);
NewSpinnerBlock.propTypes = {
  extraClass: PropTypes.string
};
NewSpinnerBlock.defaultProps = {
  extraClass: ''
};
export default NewSpinnerBlock;
